import { useFormContext } from "react-hook-form";
import { classNames, navigateTo } from "../../helper";
import { PiCheckBold } from "react-icons/pi";
import { RootState } from "../../store/root-reducer";
import { connect, useDispatch } from "react-redux";
import { useEffect, useMemo } from "react";
import { removeClaimItem } from "../../store/ace2-claim/actions";
import { useTranslation } from "react-i18next";
import { PlanCard } from "../../components/PlanCard";
import RouteNames from "../../routes/type";

function SelectItems({
  warranty_items,
  claim_items,
  warranty_id,
  claimId,
  plan,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { setValue, getValues } = useFormContext();
  const mapped_warranty_items = useMemo(
    () =>
      warranty_items.map((item) => {
        const claimItem = claim_items.find(
          ({ warrantyItem }) => warrantyItem?.id === item?.id
        );
        return {
          ...item,
          isSelected: claimItem?.id || null,
          isSavedInCRM: Boolean(claimItem?.id),
          claimItemId: claimItem?.id,
          warrntyItemId: item?.id,
        };
      }),
    [claim_items, warranty_items]
  );

  // useEffect(() => {
  //   setValue(
  //     "selectedItems",
  //     claim_items.map(({ warrantyItem }) => warrantyItem?.id),
  //     {
  //       shouldValidate: true,
  //     }
  //   );
  //   return () => {};
  // }, [claim_items, setValue]);

  useEffect(() => {
    const currentSelected = getValues("selectedItems");
    if (currentSelected && currentSelected.length > 0) return;
    const selected = mapped_warranty_items
      .filter(({ isSelected }) => isSelected)
      .map(({ warrntyItemId }) => warrntyItemId);
    setValue("selectedItems", selected, { shouldValidate: true });
  }, [setValue, getValues, mapped_warranty_items]);

  const handleUnChecked = (item) => {
    dispatch(
      removeClaimItem({
        id: item?.claimItemId,
      })
    );
  };

  return (
    <div className="space-y-2">
      <PlanCard plan={plan} />
      <span className="text-[#737B84] text-sm">
        {mapped_warranty_items.length} {t("items found")}
      </span>
      <div className="space-y-3">
        {mapped_warranty_items.map((item, index) => (
          <ClaimItemBox
            key={item.id}
            item={item}
            index={index}
            handleUnChecked={handleUnChecked}
          />
        ))}
        <button
          className="border-dashed border-2 border-brand-color my-4 flex disabled:cursor-not-allowed flex-row justify-center items-center gap-2 text-brand-color h-12 font-semibold rounded-xl w-full px-3 py-4"
          onClick={() =>
            navigateTo(
              `/${RouteNames.ADD_ACE2_WARRNTY_ITEM}?step=1&warranty_id=${warranty_id}&claimId=${claimId}`
            )
          }
        >
          {t("+ Add Missing Item")}
        </button>
      </div>
    </div>
  );
}

const ClaimItemBox = ({ item, index, handleUnChecked }) => {
  const { register, watch, unregister } = useFormContext();
  const disabled = item.returned === 1 || item.full_replacement === 1;
  const selectedItems = watch(`selectedItems`);
  const selectedItemsField = register("selectedItems", {
    validate: (_, { selectedItems }) => {
      return selectedItems?.length > 0;
    },
  });

  const checked = useMemo(() => {
    return selectedItems?.length > 0
      ? selectedItems.some((selectedId) => item.id === selectedId)
      : false;
  }, [item.id, selectedItems]);
  const { t } = useTranslation();

  return (
    <label
      key={item.id}
      className={classNames(
        checked ? "border-brand-color" : "border-[#DFDFDF]",
        "border flex transition-all rounded-xl overflow-hidden cursor-pointer py-2 select-none items-center relative",
        disabled && "bg-gray-50 border-gray-200 !cursor-not-allowed"
      )}
    >
      <input
        type="checkbox"
        className="hidden"
        value={item.id}
        disabled={disabled}
        key={item.id}
        {...selectedItemsField}
        onChange={(e) => {
          selectedItemsField.onChange(e);
          if (!e.target.checked) {
            if (item?.isSavedInCRM) {
              handleUnChecked(item, index);
            }
            unregister(`claimItems.[${item.id}]`);
          }
        }}
      />
      {disabled && item.returned === 1 && (
        <p className="absolute top-0 right-0 text-xs px-2 py-1 bg-red-100 text-red-700 rounded-bl-md">
          {t("Returned")}
        </p>
      )}
      {disabled && item.full_replacement === 1 && (
        <p className="absolute top-0 right-0 text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded-bl-md">
          {t("Full Replaced")}
        </p>
      )}
      <div className="w-9">
        <div
          className={classNames(
            checked ? "border-[#2D6CCA] " : " border-[#DFDFDF]",
            "h-4 m-2 w-4 shrink-0 cursor-pointer bg-white rounded border flex items-center justify-center transition-all",
            disabled && "bg-gray-100/80 opacity-50 cursor-not-allowed"
          )}
          aria-hidden="true"
        >
          {checked && <PiCheckBold className="size-3 text-[#2D6CCA]" />}
        </div>
      </div>
      <div className={`w-full ${disabled && "opacity-30"}`}>
        <p className="text-black text-sm font-medium block">
          {item?.name || item?.itemDescription || "-"}
        </p>
        {item?.itemDescription && (
          <p className="text-[#949494] text-sm font-medium block">
            {item?.itemDescription}
          </p>
        )}
        {(item?.sku || item?.location) && (
          <div className="flex justify-between w-full pr-3">
            <div className="text-[#2D6CCA] text-sm font-semibold">
              {item?.sku}
            </div>
            <div className="text-sm text-black font-medium">
              {item?.location}
            </div>
          </div>
        )}
      </div>
    </label>
  );
};

const mapStateToProps = (state: RootState) => ({
  warranty_items: state?.ace2Claim?.warranty_items || [],
  claim_items: state?.ace2Claim?.claim_items || [],
  warranty_id: state?.ace2Claim?.plan?.["id"] || "",
  claimId: state?.ace2Claim?.claimId || "",
  plan: state?.ace2Claim?.plan || {},
});

export default connect(mapStateToProps)(SelectItems);
